module.exports = __webpack_public_path__ + "img/dedicated-entry-2.61e53f67.png";